(function (angular) {
	'use strict';

	var placeholderInlineObject = {
		bindings: {
			placehold: '<',
			theme: '<',
			width: '<'
		},
		controller: [PlaceholderInlineFunction],
		controllerAs: 'placeholderInline',
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		transclude: true
	};

	angular
		.module('placeholderModule')
		.component('placeholderInline', placeholderInlineObject);

	function templateUrlFunction(STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/shared/placeholder/placeholder-inline.html';
	}

	function PlaceholderInlineFunction() {
		var placeholderInline = this;
		placeholderInline.placehold = true;
	}

})(window.angular);